import axios from "axios";
import toast from "react-hot-toast";

let initialized = false;
let lastForbiddenToastAt = 0;

export const setupAxiosInterceptors = () => {
    if (initialized) return;
    initialized = true;

    axios.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error?.response?.status === 403 && !error.config?.suppressForbiddenToast) {
                const now = Date.now();
                // Prevent duplicated toasts from burst requests.
                if (now - lastForbiddenToastAt > 1200) {
                    toast.error("You don't have permission to do this.");
                    lastForbiddenToastAt = now;
                }
            }

            return Promise.reject(error);
        },
    );
};
